import { createSlice as a } from "@reduxjs/toolkit";
import { AppInitialState as i } from "./InitialState.js";
const s = a({
  name: "AppState",
  initialState: i,
  reducers: {
    setVisibleTab: (e, t) => {
      e.uistate.visibleTab = t?.payload;
    },
    setShowMenu: (e, t) => {
      e.uistate.showMenu = t?.payload;
    },
    setUser: (e, t) => {
      e.datastate.user = t?.payload;
    },
    setReviews: (e, t) => {
      e.datastate.reviews = t?.payload;
    },
    setTestDetails: (e, t) => {
      e.datastate.testDetails = t?.payload;
    },
    setTestType: (e, t) => {
      e.uistate.testType = t?.payload;
    },
    setProfileComplete: (e, t) => {
      e.uistate.profileComplete = t?.payload;
    },
    setShowProfilePopUp: (e, t) => {
      e.uistate.showProfilePopUp = t?.payload;
    },
    setHasTestHistory: (e, t) => {
      e.datastate.hasTestHistory = t?.payload;
    },
    setSampleTestStatus: (e, t) => {
      e.uistate.sampleTestStatus = t?.payload;
    },
    setTheme: (e, t) => {
      e.uistate.theme = t?.payload;
    },
    setHasSeenChatSuggestions: (e, t) => {
      e.datastate.hasSeenChatSuggestions = t?.payload;
    },
    setHasDiscardedDisclaimer: (e, t) => {
      e.uistate.hasDiscardedDisclaimer = t?.payload;
    }
  }
}), {
  setReviews: l,
  setVisibleTab: r,
  setShowMenu: d,
  setUser: u,
  setTestDetails: S,
  setTestType: y,
  setProfileComplete: T,
  setShowProfilePopUp: m,
  setHasTestHistory: c,
  setSampleTestStatus: n,
  setTheme: h,
  setHasSeenChatSuggestions: f,
  setHasDiscardedDisclaimer: w
} = s.actions, D = s.reducer;
export {
  D as default,
  w as setHasDiscardedDisclaimer,
  f as setHasSeenChatSuggestions,
  c as setHasTestHistory,
  T as setProfileComplete,
  l as setReviews,
  n as setSampleTestStatus,
  d as setShowMenu,
  m as setShowProfilePopUp,
  S as setTestDetails,
  y as setTestType,
  h as setTheme,
  u as setUser,
  r as setVisibleTab
};
